import { merge } from 'lodash-es'
import moment from 'moment'

import Channels from './channels'
import Labels from './labels'
import Weeks from './weeks'

const subModules = [Weeks, Labels, Channels]

const module = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {},
  getters: {
    daysOfMonthlabel: (state, getters, rootState) => (index) => {
      const { month, year } = rootState.settings
      const formattedMonth = moment().month(month).format('MMM')
      return `${formattedMonth} ${getters.daysOfMonth[index].label}, ${year}`
    },
    monthsOfQuarterlabel: (state, getters) => (index) => getters.monthsOfQuarter[index].label,
    monthsOfYearlabel: (state, getters, rootState) => (index) => {
      const { year } = rootState.settings
      return `${getters.monthsOfYear[index].label}\`${year}`
    },
    labelChart: (state, getters, rootState) => (tooltip) => {
      const { dataIndex } = tooltip[0]
      const { viewType } = rootState.settings
      return getters[`${viewType}label`](dataIndex)
    },
    getDataset: (state, getters) => (dots) => {
      const weeksLength = getters.weeks.length
      const dotsLength = dots.length
      const nullDotsLength = weeksLength - dotsLength
      if (nullDotsLength === weeksLength) {
        return []
      }

      const dataset = new Array(weeksLength)
      dataset.fill(null)
      dots.forEach((item) => {
        dataset[item.x] = item.y >= 0 ? item.y : 0
      })

      return dataset
    },
    allStatsData(state, getters, rootState) {
      const channelsStats = rootState.budget.rtb.stats.channels.reduce((acc, item) => {
        if (state.channels[item.title]?.active) {
          return acc.concat(getters.getDataset(item.dots))
        }
        return acc
      }, [])
      const labelsStats = getters.labels.reduce((acc, item) => {
        if (state.labels[item.label].active) {
          return acc.concat(item.dataset)
        }
        return acc
      }, [])
      return [...channelsStats, ...labelsStats]
    },
    max(state, getters) {
      const stats = getters.allStatsData.filter((e) => e)
      if (stats[0] !== 0 && !stats[0]) {
        return 0
      }
      return Math.max.apply(null, stats)
    },
    middle(state, getters) {
      return Math.round(getters.max / 2)
    },
  },
}

const moduleMixin = (subModules = []) => {
  let result = { ...module }
  for (const subModule of subModules) {
    result = merge(result, subModule)
  }
  return result
}

export default moduleMixin(subModules)
